<template>
    <div>
        <h2 class="mb-3">Beratungsanfrage</h2>
        <div ref="beratung" class="beratung-form-bg">
            <div class="beratung-form-bg-color beratung-form-box">
                <div class="row">
                    <div class="col-12">
                        <div class="p-5 text-center">
                            <form @submit.prevent="beratungSenden" v-if="!sent && !loading">
                                <textarea v-model="message" class="form-control" placeholder="Ihre Nachricht:"></textarea>
                                <button class="mt-2 btn btn-success">Nachricht abschicken</button>
                            </form>
                            <div v-else-if="!sent && loading">
                                <loading-icon style="top:100px"/>
                            </div>
                            <div v-else style="margin-top: 100px">
                                <div>
                                    <img src="/img/svg/Flieger.svg" alt="gesendet">
                                </div>
                                <h2 class="success">Vielen Dank für Ihre Anfrage!</h2>
                                <p class="success">Wir werden uns in Kürze bei Ihnen zurückmelden!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                user:       null,
                message:    '',
                sent:       false,
                loading:    false
            }
        },
        methods: {
            beratungSenden() {                                
                if(!this.message) {
                    this.$bvToast.toast(this.$t('intern_meldung.kontakt_anfrage'), {
                        title:   'Fehlermeldung',
                        variant: 'danger',
                    });

                    return false;
                }
                
                this.loading = true;
                
                let form = new FormData;

                form.append('id',       this.user.id);
                form.append('message',  this.message);                

                this.$http.post('/userApi/sendKontaktAnfrage', form).then(response => {
                    if(response.data == 'OK'){
                        this.sent = true;
                    }
                }).catch(err => {
                    this.$bvToast.toast(this.$t(err.reponse.data.data), {
                        title:   'Fehlermeldung',
                        variant: 'danger',
                    });
                }).then(() => {
                    this.loading = false;
                });
            }
        },
        created() {
            document.title = 'Beratungsanfrage';
            this.user = this.$store.getters.user;

            this.$store.watch(() => {
                return this.$store.getters.user;
            }, user => {
                this.user = user;
            });
        },
    }
</script>

<style scoped>
.beratung-form-bg {
    background-image: url(https://cdn.mietmeile.de/images/vermieten/phone_woman.jpg);
    background-size: cover;
    display: inline-block;
    -webkit-border-radius: 10px;
    border-radius: 10px;
    height: 450px;
    width: 100%;
}
.beratung-form-bg-color {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    width: 100%;
    background: -moz-linear-gradient(45deg,rgba(247,247,247,0) 0,rgba(248,216,166,0) 21%,rgba(155, 255, 135, 0.44) 64%,rgba(118, 247, 63, 0.56) 76%,rgba(41, 249, 0, 0.48) 100%);
    background: -webkit-linear-gradient(45deg,rgba(247,247,247,0) 0,rgba(248,216,166,0) 21%,rgba(155, 255, 135, 0.44) 64%,rgba(118, 247, 63, 0.56) 76%,rgba(41, 249, 0, 0.48) 100%);
    background: linear-gradient(45deg,rgba(247,247,247,0) 0,rgba(248,216,166,0) 21%,rgba(155, 255, 135, 0.44) 64%,rgba(118, 247, 63, 0.56) 76%,rgba(41, 249, 0, 0.48) 100%);
    display: inline-block;
    height: 450px;
}
.beratung-form-box {
    display: inline-block;
    -webkit-border-radius: 10px;
    border-radius: 10px;
}
textarea{
    resize: none;
    height: 320px;
    -webkit-border-radius: 10px;
    border-radius: 10px;
    opacity: 0.8;
}
.success{
    text-shadow: 1px 1px black;
    color: white;
}
</style>